(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'babel-runtime/helpers/taggedTemplateLiteralLoose', 'react', 'emotion', '../../../elements', './ProgressBar', '../icons/CsvIcon.svg', '../icons/PdfIcon.svg', '../components/StatusIcon', './ValidationResponses', '../flowtypes'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/helpers/taggedTemplateLiteralLoose'), require('react'), require('emotion'), require('../../../elements'), require('./ProgressBar'), require('../icons/CsvIcon.svg'), require('../icons/PdfIcon.svg'), require('../components/StatusIcon'), require('./ValidationResponses'), require('../flowtypes'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.taggedTemplateLiteralLoose, global.react, global.emotion, global.elements, global.ProgressBar, global.CsvIcon, global.PdfIcon, global.StatusIcon, global.ValidationResponses, global.flowtypes);
    global.FileUploadStatusBox = mod.exports;
  }
})(this, function (exports, _taggedTemplateLiteralLoose2, _react, _emotion, _elements, _ProgressBar, _CsvIcon, _PdfIcon, _StatusIcon, _ValidationResponses, _flowtypes) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.FiletypeIcon = undefined;

  var _taggedTemplateLiteralLoose3 = _interopRequireDefault(_taggedTemplateLiteralLoose2);

  var _react2 = _interopRequireDefault(_react);

  var _ProgressBar2 = _interopRequireDefault(_ProgressBar);

  var _CsvIcon2 = _interopRequireDefault(_CsvIcon);

  var _PdfIcon2 = _interopRequireDefault(_PdfIcon);

  var _StatusIcon2 = _interopRequireDefault(_StatusIcon);

  var _ValidationResponses2 = _interopRequireDefault(_ValidationResponses);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _templateObject = (0, _taggedTemplateLiteralLoose3.default)(['\n    min-height: 56px;\n    padding: 16px 19px;\n    border: 1px solid #e6e6e6;\n    border-radius: 3px;\n  '], ['\n    min-height: 56px;\n    padding: 16px 19px;\n    border: 1px solid #e6e6e6;\n    border-radius: 3px;\n  ']),
      _templateObject2 = (0, _taggedTemplateLiteralLoose3.default)(['\n    height: 46px;\n    width: 38px;\n    margin-right: 19px;\n  '], ['\n    height: 46px;\n    width: 38px;\n    margin-right: 19px;\n  ']),
      _templateObject3 = (0, _taggedTemplateLiteralLoose3.default)(['\n    margin-top: 8px;\n    font-size: 13px;\n  '], ['\n    margin-top: 8px;\n    font-size: 13px;\n  ']);

  var Paragraph = _elements.typography.Paragraph;


  var styles = {
    statusBox: (0, _emotion.css)(_templateObject),
    filetypeIconContainer: (0, _emotion.css)(_templateObject2),
    totalCount: (0, _emotion.css)(_templateObject3)
  };

  var FiletypeIcon = exports.FiletypeIcon = function FiletypeIcon(_ref) {
    var filetype = _ref.filetype;
    return filetype === 'pdf' ? _react2.default.createElement(_PdfIcon2.default, null) : _react2.default.createElement(_CsvIcon2.default, null);
  };

  var FileUploadStatusBox = function FileUploadStatusBox(_ref2) {
    var isComplete = _ref2.isComplete,
        uploadPercentage = _ref2.uploadPercentage,
        filetype = _ref2.filetype,
        filename = _ref2.filename,
        className = _ref2.className,
        _ref2$errors = _ref2.errors,
        errors = _ref2$errors === undefined ? [] : _ref2$errors,
        _ref2$warnings = _ref2.warnings,
        warnings = _ref2$warnings === undefined ? [] : _ref2$warnings;

    var status = void 0;

    if (errors.length) {
      status = 'error';
    } else if (warnings.length) {
      status = 'warn';
    } else if (isComplete) {
      status = 'success';
    } else {
      status = 'loading';
    }

    return _react2.default.createElement(
      'div',
      { className: 'layout-row ' + styles.statusBox + ' ' + className },
      _react2.default.createElement(
        'div',
        { className: 'flex-none ' + styles.filetypeIconContainer },
        _react2.default.createElement(FiletypeIcon, { filetype: filetype })
      ),
      _react2.default.createElement(
        'div',
        { className: 'flex-auto' },
        _react2.default.createElement(
          'div',
          { className: 'layout-row layout-align-space-between' },
          _react2.default.createElement(
            Paragraph,
            { bold: true },
            filename
          ),
          _react2.default.createElement(_StatusIcon2.default, { status: status })
        ),
        _react2.default.createElement(_ProgressBar2.default, { percentage: uploadPercentage, status: status }),
        _react2.default.createElement(_ValidationResponses2.default, { errors: errors, warnings: warnings })
      )
    );
  };

  exports.default = FileUploadStatusBox;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/components/FileUploadStatusBox/components/FileUploadStatusBox.js
// module id = 2036
// module chunks = 1